import { useEffect } from 'react';
import { SessionTimeoutUpdate } from '@upstart/harmony/lib/legos/crossAppMessaging';
import { broadcastNewSessionTimeout } from 'util/sessionTimeout';

function isSessionTimeoutUpdateEvent(e: unknown): e is SessionTimeoutUpdate {
  return (
    typeof e === 'object' &&
    e !== null &&
    (e as { type?: unknown }).type === 'sessionTimeoutUpdate'
  );
}
export default function useCommandCenterListener() {
  useEffect(() => {
    const handleWindowEvent = (e: MessageEvent) => {
      if (e.origin !== process.env.REACT_APP_COMMAND_CENTER_URL) {
        return;
      }

      if (!isSessionTimeoutUpdateEvent(e.data)) {
        return;
      }

      broadcastNewSessionTimeout(e.data.data.newTimeoutInSeconds);
    };
    window.addEventListener('message', handleWindowEvent);

    return function unsubscribeSessionTimeoutListeners() {
      window.removeEventListener('message', handleWindowEvent);
    };
  }, []);
}
